import React from "react";
import bannerEstudio from "../../assets/estudio-banner-panoramico.jpg";

const BANNER_BG = "rgb(14, 15, 28)";
const TEXT_SCRIM =
  "linear-gradient(to right, rgba(14, 15, 28, 0.8) 0%, rgba(14, 15, 28, 0.45) 40%, rgba(14, 15, 28, 0) 75%)";
const BOTTOM_FADE =
  "linear-gradient(to top, #11121f 0%, rgba(17, 18, 31, 0) 30%)";

export const EstudioBanner = ({
  title,
  subtitle = "Revisa tus preguntas guardadas y analiza tu criterio al responder bajo duda.",
}) => {
  return (
    <>
      {/* Fondo del navbar (transparente): mantiene el offset de la barra fija */}
      <div className="h-[82px] w-full" style={{ backgroundColor: BANNER_BG }} />
      <div
        className="w-full h-[180px] desktop:h-[260px]"
        style={{
          width: "100%",
          backgroundColor: BANNER_BG,
          backgroundImage: `${BOTTOM_FADE}, url(${bannerEstudio})`,
          backgroundSize: "cover",
          backgroundPosition: "right center",
          backgroundRepeat: "no-repeat",
          marginBottom: "32px",
          position: "relative",
        }}
      >
        <div
          className="absolute inset-0 flex items-center"
          style={{
            background: TEXT_SCRIM,
          }}
        >
          <div className="page-content-shell">
            <h1
              className="font-outfit"
              style={{
                color: "#ECB236",
                margin: 0,
                fontSize: "clamp(1.5rem, 3.2vw, 3.5rem)",
                fontWeight: 800,
                textShadow: "0 2px 10px rgba(0,0,0,0.6)",
                lineHeight: 1.15,
              }}
            >
              {title || (
                <>
                  Estudia.
                  <br />
                  Decide.
                  <br />
                  Mejora.
                </>
              )}
            </h1>
            <p
              className="font-montserrat"
              style={{
                color: "#ffffff",
                margin: "10px 0 0 0",
                fontSize: "clamp(var(--font-size-body, 16px), 1.2vw, 18px)",
                fontWeight: 500,
                textShadow: "0 2px 8px rgba(0,0,0,0.6)",
                maxWidth: "480px",
                lineHeight: 1.35,
              }}
            >
              {subtitle}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default EstudioBanner;
